// removed by extract-text-webpack-plugin
module.exports = {"oySelect":"oySelect__3gQGMTwS","icon":"icon__2k4eFISU","icon_active":"icon_active__3Rkat34I","simple":"simple__3FY2dmtH","info":"info__3tMtEZcB","active":"active__3mPNYnl0","dropdown":"dropdown__1sbQOwZh","placeholder":"placeholder__1BwjSv3j","hoverHighlight":"hoverHighlight__2iz_FMEF","downIcon":"downIcon__110_IJO0","dropdownOffset":"dropdownOffset__1dUQxitA","dropdown_item":"dropdown_item__2qIZs5qS","checked":"checked__1JJSdoLz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYSelect/index.module.less
// module id = 701
// module chunks = 1